// extracted by mini-css-extract-plugin
export default {"slider":"InstructorSlider_slider__Cm99Q"};